const Selectors = {
  errors: state => state.payment.errors,
  paymentIntent: state => state.payment.paymentIntent,
  previousIntent: state => state.payment.previousIntent,
  loading: state => state.payment.loading,
  paymentMethods: state => state.payment.paymentMethods
};

export default Selectors;
